export default __webpack_public_path__ + "static/media/rabbit.5fb3a804.png";